import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=4d536f2f&scoped=true"
import script from "./Options.vue?vue&type=script&lang=ts"
export * from "./Options.vue?vue&type=script&lang=ts"
import style0 from "./Options.vue?vue&type=style&index=0&id=4d536f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d536f2f",
  null
  
)

export default component.exports